// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__m6xl_","video-play":"Video_video-play__8JALn","pulse-animation":"Video_pulse-animation__KzwCB"};